import { connect } from "react-redux";
import Project from './Project'
import { bindActionCreators } from "redux";
import {createProject, searchProject, updateProject, getPriceProject} from "../../../services/redux/Valet/Project/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    projectRes : state.CreateProject.projectRes,
    projectPricing : state.CreateProject.projectPricing,
    searchProjectRes: state.CreateProject.searchProjectRes,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createProject,
        searchProject,
        documentUploadUrlPublic,
        updateProject,
        getPriceProject
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Project);